import { adminHttpClient } from '../commons/adminHttpClient'
import DiscountType from './DiscountType'

export type UserAdvertisementsResponse = {
  advertisementId: string
  name: string
  description: string
  summary: string
  logoImage: string
  siteUrl: string
  partnershipImage: string
  discount: number
  discountCode: string
  createdAt: string
  discountType: DiscountType
}

const getUserAdvertisements = (): Promise<UserAdvertisementsResponse[]> => {
  return adminHttpClient.get(`Marketplace/UserAdvertisements`)
}

export default getUserAdvertisements
